import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { SurveyTemplate, SurveyTemplateTypes } from 'types/survey_template.types';

export interface GetSurveyTemplatesInput {
  searchText?: string;
  selectedTypeFilters: SurveyTemplateTypes[];
  perPage?: number;
  tabType?: string;
  currPage?: number;
}

export interface GetSurveyTemplatesResult {
  editableSurveyTemplates: {
    surveyTemplates: SurveyTemplate[];
    pageTotal: number;
  };
}

const GetSurveyTemplatesQuery = gql`
  query editableSurveyTemplates(
    $currPage: Int
    $tabType: String
    $searchText: String
    $perPage: Int
    $selectedTypeFilters: [String]
  ) {
    editableSurveyTemplates(
      page: $currPage
      tabType: $tabType
      searchText: $searchText
      perPage: $perPage
      selectedTypeFilters: $selectedTypeFilters
    ) {
      surveyTemplates {
        id
        title
        description
        createdBy
        creatorOnly
        creator
        questions {
          id
          isDeleted
          shownBefore
          isRequired
          label
          options
          hasOtherOption
          type
          sort
          properties {
            scaleMinValue
            scaleMaxValue
            scaleMinLabel
            scaleMaxLabel
          }
        }
        editedAt
        publishedAt
        isPublished
        isArchived
        archivedAt
        type
      }
      pageTotal
    }
  }
`;

export const getSurveyTemplates = (
  input: GetSurveyTemplatesInput
): Promise<GetSurveyTemplatesResult> => {
  return gqlClient.request<GetSurveyTemplatesResult>(GetSurveyTemplatesQuery, input);
};
